var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2f2f37;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "start",
    className: "cls-1",
    d: "M8.007,7.665A1.171,1.171,0,1,1,7.1,6.928L8.919,4.671a.586.586,0,0,1,.912.736ZM7.26,13.818c-.114.007-.231.01-.346.01a5.742,5.742,0,1,1,5.741-5.849.586.586,0,1,0,1.172-.021A6.914,6.914,0,0,0,7.5,1.2V.586a.586.586,0,0,0-1.172,0V1.2a6.914,6.914,0,0,0-4.3,11.778A6.869,6.869,0,0,0,6.914,15c.138,0,.278,0,.416-.012a.586.586,0,0,0-.069-1.17ZM10.9,1.447l1.581,1.312a.586.586,0,0,0,.749-.9L11.654.545a.586.586,0,1,0-.749.9ZM.968,2.894a.584.584,0,0,0,.37-.132L2.948,1.45a.586.586,0,1,0-.74-.908L.6,1.854a.586.586,0,0,0,.371,1.04ZM15,11.484a1.036,1.036,0,0,1-.5.892l-4.064,2.471a1.044,1.044,0,0,1-1.587-.892V9.014a1.044,1.044,0,0,1,1.587-.892L14.5,10.592a1.036,1.036,0,0,1,.5.892Zm-1.29,0-3.69-2.244v4.487Z",
    transform: "translate(0 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.a09f58ca.svg";
export { ForwardRef as ReactComponent };